// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { SignInTypeEnum } from '~/utils/enum/common';
import { IFormLogin } from '~/utils/interface/auth';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      email: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' }))
        .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
          if (value && !REG_EXP.EMAIL.test(value)) return false;
          return true;
        }),
      password: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IFormLogin = {
  type: SignInTypeEnum.STANDARD,
  email: EMPTY_STRING,
  password: EMPTY_STRING,
};
